export default __webpack_public_path__ + "static/media/16.ae4c518b.jpg";